// Persisted per-browser device identifier used only for the zero-trust
// super-admin login flow (see LoginVerifyDeviceOtp in login_routes.py):
// once a device has been through the OTP challenge once, the backend
// recognizes this token and skips OTP on future logins from the same
// browser. Regular admin/end-user accounts never see this -- it's a
// no-op extra field for them.
const DEVICE_TOKEN_KEY = "clamphook-device-token";

export function getOrCreateDeviceToken(): string {
  if (typeof window === "undefined") return "";
  let token = window.localStorage.getItem(DEVICE_TOKEN_KEY);
  if (!token) {
    token =
      window.crypto && window.crypto.randomUUID
        ? window.crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    window.localStorage.setItem(DEVICE_TOKEN_KEY, token);
  }
  return token;
}
